import React, { useEffect, useState } from 'react'
import "./Trending.css";
import { GlobalDataState } from '../../../Context';
import {Link} from 'react-router-dom'

const Trending = () => {
    const [trendingData,settrendingData]=useState({});
    const {setClickedId,setAllData}=GlobalDataState();
    useEffect(()=>{
       getTrending();
    },[])
    

    const {
        state:{stack},
        dispatch,
    }=GlobalDataState();
    
    async function getTrending(){
        const data=await fetch(`https://api.themoviedb.org/3/trending/all/day?api_key=95827c3fee6b7922a023ac65e529dca2`)
        const json=await data.json();
        // console.log(json);
        settrendingData(json?.results);
        
    }
    function handlesetId(idx){
        setClickedId(idx);
     }

     let box = document.querySelector('.Titems');

     const btnpressprev = () => {
         let width = box.clientWidth;
         box.scrollLeft = box.scrollLeft - width;
         console.log(width)
     }
 
     const btnpressnext = () => {
         let width = box.clientWidth;
         box.scrollLeft = box.scrollLeft + width;
         console.log(width)
     }
  return (
    <div>
    <h2>Trending</h2>
    <div className='Titems'>
    <button className="Tpre-btn" onClick={btnpressprev}><p>&lt;</p></button>
    <button className="Tnext-btn" onClick={btnpressnext}><p>&gt;</p></button>
        {
            Object.values(trendingData).map((item)=>(
                <div className='item'>
                <Link to={"/moviesdetails"}style={{textDecoration:'none',color:'inherit'}}>
                <div className='Titem' onClick={()=>handlesetId(item.id)}>
                
                <img className='img' src={`https://image.tmdb.org/t/p/w500/${item.poster_path}`}></img>
                <div>{item.vote_average}</div>
                <div style={{wordWrap:'wordBreak',overflow:"hidden"}}>
                    {
                        item.title? <a style={{wordWrap:'break-word',flexWrap:"wrap",overflow:"hidden",maxWidth:"11rem",width:"auto",fontWeight:"bold"}}>{item.title}</a>:<a style={{wordWrap:'break-word',flexWrap:"wrap",overflow:"hidden",maxWidth:"11rem",width:"auto",fontWeight:"bold"}}>{item.name}</a>
                    }
                </div>
                {/* <div>{item.release_date?item.release_date:<h5>upcoming</h5>}</div> */}
                </div>
                
                </Link>
                
                <div>
                <button onClick={()=>dispatch({type:"ADD_TO_STORE",payload:item,})} style={{borderRadius:"1rem",backgroundColor:"#16FF00"}}>ADD</button>
                <button onClick={()=>dispatch({type:"REMOVE_FROM_STORE",payload:item,})} style={{borderRadius:"1rem",backgroundColor:"#FF0303"}}>REMOVE</button>
                </div>
                </div>
            ))
        }
    </div>
    </div>
  )
}

export default Trending